import BaseApi from "../base";

export default class Static extends BaseApi {

}

